import { useMutation } from "@apollo/client";

import { GqlFieldworkerUpdateAvailabilityInput, gql } from "~/__generated__";

import { FIELDWORKER_GET_CALENDAR_DAYS_EVENTS } from "./useFieldworkerGetCalendarDaysEvents";

const FIELDWORKER_UPDATE_AVAILABILITY = gql(`
    mutation fieldworkerUpdateAvailability($input: GqlFieldworkerUpdateAvailabilityInput!) {
        fieldworkerUpdateAvailability(input: $input)
    }
`);

export default function useFieldworkerUpdateAvailability() {
    const [fieldworkerUpdateAvailability, { loading, error }] = useMutation(FIELDWORKER_UPDATE_AVAILABILITY, {
        refetchQueries: [FIELDWORKER_GET_CALENDAR_DAYS_EVENTS],
    });

    return {
        fieldworkerUpdateAvailability: (
            fieldworkerUserId: string,
            availabilities: GqlFieldworkerUpdateAvailabilityInput["availabilities"],
        ) =>
            fieldworkerUpdateAvailability({
                variables: {
                    input: {
                        availabilities,
                        targetId: fieldworkerUserId,
                    },
                },
            }),
        loading,
        error,
    };
}
